module.exports = __webpack_public_path__ + "img/img3.18211915.jpeg";